import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-access-item-body',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './access-item-body.component.html',
  styleUrl: './access-item-body.component.scss',
})
export class AccessItemBodyComponent {}
